var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'text-A3': _vm.row.bindUserNumber < _vm.row.totalUserNumber }},[_vm._v(_vm._s(_vm.row.bindUserNumber)+"/"+_vm._s(_vm.row.totalUserNumber))])}
var staticRenderFns = []

export { render, staticRenderFns }